import { useMemo } from "react";

import { Code } from "components/icons/generated";
import { AccountContext } from "views/AccountWrapper";
import useTypedContext from "hooks/useTypedContext";

import type { MainNavigationItem } from "../types";
import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useShareCodeConfigGroup = (): MainNavigationItem => {
  const { viewer } = useTypedContext(AccountContext);

  return useMemo(
    () => ({
      id: "share-code-config",
      title: "Share Code & Config",
      icon: Code,
      items: [
        {
          items: [
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.ModuleRegistry],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Providers],
            ...(viewer.admin
              ? [MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.GPGKeys]]
              : []),
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Contexts],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Blueprints],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.TemplateWorkbench],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.SpaceliftRepos],
          ],
        },
      ],
    }),
    [viewer.admin]
  );
};

export default useShareCodeConfigGroup;
